import { classNames } from '@/utils/classNames';

const baseStyles = 'rounded-full px-[5px] py-1 font-GMedium text-[10px] leading-[8px]';

const variantStyles = {
    info: `${baseStyles} bg-icoBlue-100 text-icoBlue`,
    warning: `${baseStyles} bg-[#FAEBDA] text-[#6F301F]`,
    error: `${baseStyles} bg-icoRed-100 text-icoRed`,
    success: `${baseStyles} bg-icoGreen-100 text-icoGreen`
} as const;

export type PillVariant = keyof typeof variantStyles;

export type PillProps = {
    variant?: PillVariant;
    children: React.ReactNode;
    className?: string;
};

export function Pill({ variant = 'warning', children, className }: PillProps) {
    return <span className={classNames(variantStyles[variant], className)}>{children}</span>;
}
